import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { IndexVo, indexClassListVo, classListVo, articleDetailVo, SearchQuery, SearchVo } from './types';
/**
 * 帮助中心首页
 */
export const indexOverview = (): AxiosPromise<IndexVo> => {
  return request({
    url: '/member/helpCenter/indexOverview',
    method: 'get'
  });
};
/**
 * 一级分类列表
 */
export const indexClassList = (): AxiosPromise<indexClassListVo[]> => {
  return request({
    url: '/member/helpCenter/indexClassList',
    method: 'get'
  });
};

/**
 * 一级分类列表
 */
export const classList = (params: { linkUrl: string }): AxiosPromise<classListVo[]> => {
  return request({
    url: '/member/helpCenter/classList',
    method: 'get',
    params
  });
};

/**
 * 文章详情
 */
export const articleDetail = (params: { linkUrl: string }): AxiosPromise<articleDetailVo> => {
  return request({
    url: '/member/helpCenter/articleDetail',
    method: 'get',
    params
  });
};
/**
 * 反馈是否有帮助
 */
export const feedBack = (data: { articleId: string; helpful: number }): AxiosPromise<boolean> => {
  return request({
    url: '/member/helpCenter/feedBack',
    method: 'post',
    data
  });
};

/**
 * 搜索
 */
export const search = (data: SearchQuery): AxiosPromise<SearchVo[]> => {
  return request({
    url: '/member/helpCenter/search',
    method: 'post',
    data
  });
};
/**
 * 获取搜索记录
 */
export const searchRecord = (): AxiosPromise<{ content: string }[]> => {
  return request({
    url: '/member/helpCenter/searchRecord',
    method: 'get'
  });
};
